import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import sameOrBefore from 'dayjs/plugin/isSameOrBefore';
import utc from 'dayjs/plugin/utc';

dayjs.extend(calendar);
dayjs.extend(utc);
dayjs.extend(sameOrBefore);

type DateDifference = {
  days: number;
  hours: number;
};

export const dateDifference = (date: Date | string): DateDifference => {
  const currentDate = dayjs();
  const receivedDate = dayjs(date);

  let hours = currentDate.diff(receivedDate, 'hours');
  const days = Math.floor(hours / 24);
  hours = hours - days * 24;

  return { days, hours };
};

export const isSameOrBefore = (date: Date | string, toDate: Date): boolean => {
  const other = dayjs(toDate);
  const receivedDate = dayjs(date);

  return receivedDate.isSameOrBefore(other);
};

export const isSame = (date: Date, toDate: Date): boolean => {
  const other = dayjs(toDate);
  const receivedDate = dayjs(date);

  return receivedDate.isSame(other);
};

export const formatDateWithReference = (date: Date | string): string => {
  const d = dayjs(date).calendar(dayjs());
  return d;
};

export const formatDate = (date: Date | string, format: string = 'M/D/YYYY'): string => {
  return dayjs(date).format(format);
};

export const formatDateWithUtc = (date: Date | string, format: string = 'M/D/YYYY'): string => {
  const d = new Date(date);
  return dayjs(d).utc(false).format(format);
};

export const formatTestDriveDate = (date: Date): string => {
  const formattedDate = dayjs(date).format('M/D/YY, h:mm A');
  return formattedDate.replace(',', ' at');
};

export const formatDateTime = (date: Date): string => {
  return dayjs(date).format('M/D/YY h:mm A');
};

export const currentYear = (): number => {
  return new Date().getFullYear();
};

export const todaysDate = (): string => {
  return dayjs().format('MMMM D, YYYY');
};

export const convertDate = (date: Date | string): Date => {
  return dayjs(date).toDate();
};

export const formatBirthDate = (birthday: string): string => {
  const birthDate = new Date(birthday);
  birthDate.setMinutes(birthDate.getMinutes() + birthDate.getTimezoneOffset());
  return dayjs(birthDate).format('MM/DD/YYYY');
};

export const timeStrToNum = (time: string): number => {
  if (time !== '') {
    // split "01:30 AM" into
    // [0]: "01:30"
    // [1]: "AM"
    const aptTimeStrings = time.split(' ');

    // split "01:30" into
    // [0]: "01"
    // [1]: "30"
    const times = aptTimeStrings[0].split(':');

    // convert strings to numbers
    const hour = Number(times[0]);
    const minute = Number(times[1]);

    // check if time is PM
    const isPm = aptTimeStrings[1].match(/pm/i);

    // add 12 hours if time is PM and not 12 noon.
    // multiply by 100 and then add the minutes so
    // we get values like these:
    // 130 (01:30 AM)
    // 1500 (03:00 PM)
    if (isPm && hour != 12) {
      return (hour + 12) * 100 + minute;
    } else {
      return hour * 100 + minute;
    }
  } else {
    return 2300;
  }
};

export const getExpireDate = (): Date => {
  const expireDate = dayjs().utc().add(1, 'day');
  expireDate.set('hour', 5).set('minute', 0).set('second', 0);
  return expireDate.toDate();
};

export const isDateFromLastDays = (date: Date, days: number): boolean => {
  return Boolean(date) && date > dayjs().utc().subtract(days, 'day').toDate();
};
